class FinancialOperation {
  amount = 0.0;
  note = "";
  agencyid = null;
  operationType = null;
  type = "";
}
export default FinancialOperation;
